import React from 'react';
import { STATUS_STYLES, slug } from './utils';

export const StatusBadge = ({ status, testId }) => (
  <span
    data-testid={testId || `status-badge-${slug(status)}`}
    className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-semibold ${
      STATUS_STYLES[status] || 'bg-gray-100 text-gray-700'
    }`}
  >
    {status === 'Overdue' && <span className="h-1.5 w-1.5 rounded-full bg-white animate-pulse" />}
    {status}
  </span>
);
